import { useState, useCallback } from "react";

const getQueryString = () => {
  return window.location.search;
};

const setQueryStringWithoutPageReload = (qsValue) => {
  const newurl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname + 
    (qsValue !== '' ? '?'+qsValue : '');
  window.history.pushState({ path: newurl }, "", newurl);
};

function useQueryString(initialValue) {
  const [value, setValue] = useState(getQueryString());
  const onSetValue = useCallback((newValue) => {
      console.log(newValue)

      setValue(newValue);
      setQueryStringWithoutPageReload(newValue);
  },[]);

  return [value, onSetValue];
}

export default useQueryString;
